import CTAButton from './CTAButton.client'
import { AnchorHTMLAttributes, ReactNode } from 'react'
import { Cta_Button } from '@/src/generated/graphql'
import { Except } from 'type-fest'

export type CTAButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  Except<Partial<Cta_Button>, 'text'> & {
    text?: ReactNode
  }

export default CTAButton
